export default __webpack_public_path__ + "assets/illustrations/VerifyLoadIllustration.a6f442779d5c0c84e7ba2e4f75a69136.gif";